import { withInstall } from '@tw-element/utils'

import Icon from './src/icon.vue'

export const TwIcon = withInstall(Icon)
export default TwIcon

export * from './src/icon'
